import type { VaMixResponse } from '../../../services/vaMonitoringOverview';
import type { VirtualAppointmentStatus } from '../../../services/virtualAppointments';

export interface VaMixSegment {
    status: VirtualAppointmentStatus;
    count: number;
}

export interface VaMixRow {
    key: string;
    label: string;
    total: number;
    segments: VaMixSegment[];
}

export interface VaMixChart {
    statuses: VirtualAppointmentStatus[];
    rows: VaMixRow[];
}

// Totals are recomputed from the shown statuses, so dropping planned re-sorts and hides types.
export function buildVaMix(data: VaMixResponse, includePlanned: boolean): VaMixChart {
    const statuses = includePlanned
        ? data.statuses
        : data.statuses.filter((status) => status !== 'planned');
    const rows = data.types
        .map((type) => {
            const segments = statuses.map((status) => ({
                status,
                count: type.counts[status] ?? 0
            }));
            const total = segments.reduce((sum, segment) => sum + segment.count, 0);
            return { key: type.key, label: type.label, total, segments };
        })
        .filter((row) => row.total > 0)
        .sort((a, b) => b.total - a.total);
    return { statuses, rows };
}
